module.exports = __webpack_public_path__ + "fonts/CashSans-ExtlightItl.99a6e72.woff2";